import { render, staticRenderFns } from "./gongyingshangList.vue?vue&type=template&id=0d278f8a&scoped=true&"
import script from "./gongyingshangList.vue?vue&type=script&lang=js&"
export * from "./gongyingshangList.vue?vue&type=script&lang=js&"
import style0 from "./gongyingshangList.vue?vue&type=style&index=0&id=0d278f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d278f8a",
  null
  
)

export default component.exports